export enum SoloContentTitleVariant {
  Default = 'Default',
  Alternative = 'Alternative',
}

export enum SoloContentTitleSize {
  Small = 'Small',
  Big = 'Big',
}
